import { createStoreForProduct } from './ProductStore'

export const MitigationStore = createStoreForProduct('mitigation')
